import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import Input from '../Input';
import ThankYou from '../ThankYou';
import Popup from '../Popup';

class PasswordResetID extends Component {
	constructor(props) {
		super(props);

		this.reset_id = this.props.match.params.reset_id;

		this.state = {
			password: '',
			password_confirm : '',
			passwordReset: false
		}

		this.Auth = new AuthService();

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

		this.showMessage = this.showMessage.bind(this);
		this.hideMessage = this.hideMessage.bind(this);
		this.loadingButton = this.loadingButton.bind(this);
		this.removeLoadingButton = this.removeLoadingButton.bind(this);
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	handleSubmit(event) {
		const data = new FormData(event.target);
		var target = document.querySelector('.pp-button');

		this.loadingButton(target);

		this.Auth.resetPassword(data)
			.then((result) => {
				this.removeLoadingButton(target);
				if (result.success === true) {
					this.setState({
						passwordReset: true
					});
				} else {
					this.showMessage(result.message);
				}
			},
			(error) => {
				console.log(error);
				this.removeLoadingButton(target);
				this.showMessage("Something went wrong. Please try again later.");
			}
		);
		event.preventDefault();
	}

	showMessage(body, title, actionButtons) {
		var messageTitle = title || ' ',
			messageActionButtons = actionButtons || <button className="pp-button" onClick={this.hideMessage}>Close</button>;

		this.setState({
			message: {
				body: body,
				title: messageTitle,
				actionButtons: messageActionButtons
			}
		});
	}

	hideMessage() {
		this.setState({
			message: false
		});
	}

	loadingButton(target) {
		target.disabled = true;
		target.classList.add('pp-loading');
	}

	removeLoadingButton(target) {
		target.disabled = false;
		target.classList.remove('pp-loading');
	}

	render() {

		const { message } = this.state;

		return (
			<Page pageClass="pp-password-reset-page">

				{message &&
					<Popup body={message.body} title={message.title} actionButtons={message.actionButtons} />
				}

				{!this.state.passwordReset &&
					<PageSection className="pp-user-flow">

						<form id="resetpassword" className="pp-form-wrapper" onSubmit={this.handleSubmit}>
							<div className="pp-form-row">
								<Input
									type="text"
									htmlName="user_email"
									label="Email Address"
									placeholderText="Email"
									onChange={this.handleInputChange}
									value={this.state.user_email}
								/>
							</div>
							<div className="pp-form-row">
								<Input
									type="password"
									htmlName="password"
									label="New Password"
									placeholderText="New Password"
									onChange={this.handleInputChange}
									value={this.state.password}
								/>
							</div>

							<Input
								type="hidden"
								htmlName="password_reset_code"
								value={this.reset_id}
							/>

							<div className="pp-action-buttons">
								<button type="submit" className="pp-button">Reset My Password</button>
							</div>
						</form>

					</PageSection>
				}
				{this.state.passwordReset &&
					<ThankYou
						className="pp-message"
						title="Your Password has been Reset"
						message="You can login with your new password."
					/>
				}

			</Page>
		);
	}
}

export default PasswordResetID;



// WEBPACK FOOTER //
// ./src/components/pages/PasswordResetID.js